import appPricings from "../../views/appSettings/pricings.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "pricings";
  const params = ["page", "limit"];

  $stateProvider.state("pricings", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appPricings,
      },
    },
    reloadOnSearch: false,
    data: { title: "Pricings" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/pricings/pricings.urls.js